import { Button, Form, Input } from 'antd';
import propType from 'prop-types';
import React from 'react';
import { EMAIL_PATTERN } from '../../../../config/patterns';

/**
 *
 * @param {Function} props.handleSubscribeForm
 * @param {boolean} props.subscribeLoadingStatus
 */
const SubscriptionForm = ({ handleSubscribeForm, subscribeLoadingStatus }) => (
  <Form
    className="subscription-form"
    layout="inline"
    onFinish={handleSubscribeForm}
    target="hidden-frame"
  >
    <Form.Item
      className="subscription-form__item"
      rules={[
        {
          required: true,
          message: 'Invalid email',
          pattern: EMAIL_PATTERN
        }
      ]}
      name="email"
    >
      <Input
        id="subscription-form__email"
        placeholder="Your email here"
        name="email"
        aria-label="Email"
      />
    </Form.Item>
    <Form.Item>
      <Button
        className="submit-btn"
        htmlType="subscribe"
        loading={subscribeLoadingStatus}
      >
        Subscribe
      </Button>
    </Form.Item>
  </Form>
);

SubscriptionForm.propTypes = {
  handleSubscribeForm: propType.func.isRequired,
  subscribeLoadingStatus: propType.bool.isRequired
};

export default SubscriptionForm;
